import { useCallback, useState } from 'react';

import { useGetCamerasListQuery } from 'src/redux/api/connectInstance';

export const useCamera = (rdConnectInstanceId?: number) => {
  const [requested, setIsReuested] = useState(false);

  const { data, isLoading, refetch } = useGetCamerasListQuery(
    { rdConnectInstanceId },
    { skip: !rdConnectInstanceId || !requested },
  );

  const getCameraData = useCallback(() => {
    if (!requested) {
      setIsReuested(true);
    }

    return {
      cameras: data?.cameras,
      defaultCamera: data?.cameras?.find(({ isDefault }) => !!isDefault),
      isLoading,
      refresh: refetch,
    };
  }, [data, requested, isLoading, refetch]);

  return { getCameraData };
};
